import { render } from "./TopElement.vue?vue&type=template&id=197995fd"
import script from "./TopElement.vue?vue&type=script&lang=js"
export * from "./TopElement.vue?vue&type=script&lang=js"

import "./TopElement.vue?vue&type=style&index=0&id=197995fd&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__